import * as ClientTypes from "../DataTypes/clientTypes";
import * as LocaleHelper from "../../Common/localeHelper";

export function discountText(discount: number, discountType: ClientTypes.DiscountType, currencySymbol): string {
    return `${discount > 0 && discountType === ClientTypes.DiscountType.Percentage ? 100 * discount + "%" : LocaleHelper.amountToCurrency(discount, currencySymbol)}`;
}
